export default __webpack_public_path__ + "static/media/3.16b7a3a8.webp";